'use client';
import LeaderCard from '@/containers/OurLeadership/LeaderCard';
import { TypeOurPeopleWithoutUnresolvableLinksResponse } from '@/features/contentful/_generated';

const GroupBoard = ({
    hidePreview = false,
    peoples,
    handleModalOpen,
}: {
    hidePreview?: boolean;
    peoples: TypeOurPeopleWithoutUnresolvableLinksResponse[];
    handleModalOpen: (entityId: string) => void;
}) => {
    return (
        <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-2 md:tw-grid-cols-3 lg:tw-grid-cols-3 tw-gap-3 lg:tw-gap-5">
            {peoples.map((people) => (
                <LeaderCard
                    key={people.sys.id}
                    id={people.sys.id}
                    image={`https:${people.fields.picture?.fields.file?.url}`}
                    imageAlt={people.fields.picture?.fields.title}
                    name={people.fields.name}
                    position={people.fields.position}
                    onModalOpen={() => {
                        handleModalOpen(people.sys.id);
                    }}
                    hidePreview={hidePreview}
                />
            ))}
        </div>
    );
};

export default GroupBoard;
